import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './CSS/AdminHome.css';
import './CSS/DepartmentMenu.css';
import './CSS/Profile_model.css';
import SemResultUpdate from './SemResultUpdate.js';

const DepartmentMenu = () => {

  const storedHODInfo = localStorage.getItem('hodInfo');

  // Parse the JSON string back into an object
  const hodInfo = storedHODInfo ? JSON.parse(storedHODInfo) : null;

  // Access individual properties
  let instituteName, departmentName;
  if (hodInfo) {
    instituteName = hodInfo.instituteName;
    departmentName = hodInfo.departmentName;



  } else {
    console.log('No hod info found in local storage.');
  }

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [showNavBar, setShowNavBar] = useState(true);
  const [showUpdateSemResForm, setShowUpdateSemResForm] = useState(true);
  const [showConfirmationPrompt, setShowConfirmationPrompt] = useState(false);
  const [students, setStudents] = useState([]);


  const [deviceType, setDeviceType] = useState(null);
  const overlayClass = `loading-overlay${loading || isLoading ? ' visible' : ''}`;
  const [mobile, setMobile] = useState(false);


  useEffect(() => {
    // Detect device type and set the state
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    setDeviceType(isMobile ? 'mobile' : 'desktop');
    if (deviceType === 'mobile') {
      setMobile(true);
    }
  }, []);

  const navigate = useNavigate();
  const handleLogout = () => {
    setShowConfirmationPrompt(false);
    navigate('/');
  };

  if (error) {
    return <p>Error fetching student data: {error.message}</p>;
  }

  const handleSemResButtonClick = () => {
    setShowUpdateSemResForm(true);
    setIsLoading(true);
    document.querySelectorAll('.admin-chart-container').forEach((element) => {
      element.style.display = 'none';
    });
    const messageElement = document.createElement('div');
    messageElement.style.color = 'black';
    document.querySelector('.profile-right-content-container').appendChild(messageElement);
    setTimeout(() => {
      setIsLoading(false);
      messageElement.remove();
      setShowUpdateSemResForm(true);
    }, 1000);
  };


  const handleShowNav = () => {
    setShowNavBar((prevShowNavBar) => !prevShowNavBar);
  };

  function getInstituteFullName(instituteName) {
    const instituteNameMap = {
      "KIOT": "KNOWLEDGE INSTITUTE OF TECHNOLOGY",
      "MHS": "MUNICIPAL HIGHER SECONDARY SCHOOL",
      "PSG": "PSG ENGINEERING COLLEGE",
    };
    return instituteNameMap[instituteName] || instituteName;
  }

  if (deviceType === 'mobile') {
    return (
      <div className="mobile-warning-overlay-message">
        <p>You are logged in on a mobile device. Please logout from the mobile device to access this page on a computer or laptop.</p>
      </div>
    );
  }
  const imageUrl = `./uploads/dashboard-brand-logo.JPG`;

  return (
    <div className="dep-admin-page-container">
      {showNavBar &&
        <nav className="navigation1">
          <ul>
            <li>
              <div className="student-details-card">
                <div className="image-container">
                  <img src={imageUrl} alt="brand-logo" />
                </div>
                <p>
                  HOD
                  <br />
                  {instituteName}
                  <br />
                </p>
              </div>
            </li>
            <li>
              <a href="#" className="test-score-button" onClick={handleSemResButtonClick} title="View Attendance">
                Update Sem Results
              </a>
            </li>
            <br />
            <br />
          </ul>
        </nav>
      }

      <div
        className={`profile-right-content-container ${showNavBar ? "with-nav-bar" : "without-nav-bar"
          }`}>
        <header
          className="admin-header">
          <div className='nav-bar-hider'>
            <img src="./uploads/nav-menu.png" href="#" onClick={handleShowNav} id='nav-menu-button' alt="Dashboard-icon Icon"
              className={`nav-button-menu ${showNavBar ? "with-nav-bar" : "without-nav-bar"
                }`} />
          </div>
          <div className='header-dialogue'>
            <p>{getInstituteFullName(instituteName)}</p>
          </div>
          <div >
            <button className='logout-button' onClick={() => setShowConfirmationPrompt(true)}>
              Logout
            </button>
          </div>
          {showConfirmationPrompt && (
            <div className="logout-overlay">
              <div className="confirmation-container">
                <p>Are you sure you want to logout?</p>
                <button className="confirm-button" onClick={handleLogout}>Yes</button>
                <button className="cancel-button" onClick={() => setShowConfirmationPrompt(false)}>No</button>
              </div>
            </div>
          )}
        </header>
        <main
          className={`profile-content-container ${showNavBar ? "with-nav-bar" : "without-nav-bar"
            }`}>

          <div>
            {(loading || isLoading) && <div className={overlayClass}>
              <div className="spinner">
                <img src="./uploads/loading-brand-logo.png" alt="loading-brand-logo" id="loading-brand-logo" />
              </div>
              <img src="./uploads/loading-brand-title.png" alt="loading-brand-title" id="loading-brand-title" />
            </div>}
          </div>

          {showUpdateSemResForm &&
            <SemResultUpdate students={students} />
          }
        </main>
      </div>
    </div>
  );
};
export default DepartmentMenu;
